import { colors } from '@configs/styles/config'
import { SVGProps } from 'react'
import * as React from 'react'

export const TransparentRevenueIcon: React.FC<SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    width="66%"
    viewBox="0 0 150 144"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M40.9318 103.657C40.5452 103.657 40.1523 103.581 39.7719 103.43C19.5356 95.274 6.45215 75.8066 6.45215 53.8446C6.45215 24.3922 30.2306 0.431885 59.4595 0.431885C88.6883 0.431885 112.467 24.3922 112.467 53.8446C112.467 71.4959 103.799 88.0287 89.287 98.0829C87.8589 99.0757 85.9257 98.705 84.9529 97.2723C83.98 95.8395 84.3355 93.8853 85.7573 92.905C98.5726 84.0322 106.231 69.4222 106.231 53.8446C106.231 27.8546 85.2522 6.71573 59.4595 6.71573C33.6667 6.71573 12.6883 27.8546 12.6883 53.8446C12.6883 73.224 24.2314 90.3914 42.0918 97.599C43.6945 98.2462 44.4677 100.075 43.8254 101.677C43.339 102.909 42.1728 103.657 40.9318 103.657Z"
      fill={props.color ? props.color : colors.uguPurple}
    />
    <path
      d="M63.3643 75.7578H47.3226C45.5516 75.7578 44.1143 74.374 44.1143 72.669C44.1143 70.964 45.5516 69.5802 47.3226 69.5802H63.3643C66.9063 69.5802 69.781 66.8065 69.781 63.4027C69.781 59.9988 66.9063 57.2251 63.3643 57.2251H56.9476C49.87 57.2251 44.1143 51.6839 44.1143 44.87C44.1143 38.0562 49.87 32.515 56.9476 32.515H72.9893C74.7603 32.515 76.1976 33.8987 76.1976 35.6037C76.1976 37.3087 74.7603 38.6925 72.9893 38.6925H56.9476C53.4056 38.6925 50.5309 41.4662 50.5309 44.87C50.5309 48.2739 53.4056 51.0476 56.9476 51.0476H63.3643C70.4419 51.0476 76.1976 56.5888 76.1976 63.4027C76.1976 70.2165 70.4419 75.7578 63.3643 75.7578Z"
      fill={props.color ? props.color : colors.uguPurple}
    />
    <path
      d="M60.1572 38.0953C58.2322 38.0953 56.6699 36.7413 56.6699 35.0729V22.9835C56.6699 21.3152 58.2322 19.9612 60.1572 19.9612C62.0822 19.9612 63.6446 21.3152 63.6446 22.9835V35.0729C63.6446 36.7413 62.0822 38.0953 60.1572 38.0953Z"
      fill={props.color ? props.color : colors.uguPurple}
    />
    <path
      d="M60.1572 88.3127C58.2322 88.3127 56.6699 86.8545 56.6699 85.0579V72.0385C56.6699 70.2419 58.2322 68.7837 60.1572 68.7837C62.0822 68.7837 63.6446 70.2419 63.6446 72.0385V85.0579C63.6446 86.8545 62.0822 88.3127 60.1572 88.3127Z"
      fill={props.color ? props.color : colors.uguPurple}
    />
    <path
      d="M3.9818 144.11C2.95558 144.11 1.95424 143.595 1.35717 142.66C0.436677 141.197 0.865824 139.257 2.30875 138.328L70.7234 94.3852C71.9549 93.5942 73.5595 93.77 74.5919 94.8121L97.2683 117.7L144.823 69.7018C146.036 68.4777 148.007 68.4777 149.22 69.7018C150.433 70.9259 150.433 72.9159 149.22 74.14L99.4638 124.361C98.251 125.585 96.2794 125.585 95.0666 124.361L71.9486 101.027L5.65485 143.62C5.13863 143.953 4.56022 144.11 3.9818 144.11Z"
      fill={props.color ? props.color : colors.uguPurple}
    />
    <path
      d="M147.062 100.867C145.368 100.867 143.993 99.4297 143.993 97.6587V75.2004H122.511C120.817 75.2004 119.442 73.763 119.442 71.992C119.442 70.221 120.817 68.7837 122.511 68.7837H147.062C148.756 68.7837 150.131 70.221 150.131 71.992V97.6587C150.131 99.4297 148.756 100.867 147.062 100.867Z"
      fill={props.color ? props.color : colors.uguPurple}
    />
  </svg>
)
